import React from "react";
import { useDispatch, useSelector } from "react-redux";
import * as Action from "../redux/default/reducer";
import ProductsCount from "../components/products_count";
import { selectDefaultReducer, selectProductsCount } from "../redux/default/selectors";

const ProductsCountContainer = () => {
  const dispatch = useDispatch();

  const productsCount = useSelector(selectProductsCount);
    const {
    checkUncheckAllState,
    translations
  } = useSelector(selectDefaultReducer);

  const onCheckAllClick = (e) => {
    e.preventDefault();
    dispatch(Action.checkAllProducts());
  };

  const onUncheckAllClick = (e) => {
    e.preventDefault();
    dispatch(Action.uncheckAllProducts());
  };

  return (
    <ProductsCount
      productsCount={productsCount}
      checkUncheckAllState={checkUncheckAllState}
      translations={translations}
      onCheckAllClick={onCheckAllClick}
      onUncheckAllClick={onUncheckAllClick}
    />
  );
};

export default ProductsCountContainer;